//* Libraries imports
import { X } from "lucide-react";

type PixTimeExceededModalProps = {
  visible: boolean;
  onClose: () => void;
  onGenerateNewPix?: () => void;
  onFinalize?: () => void;
};

export function PixTimeExceededModal({
  visible,
  onClose,
  onGenerateNewPix,
  onFinalize,
}: PixTimeExceededModalProps) {
  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 animate-in fade-in duration-200">
      <div className="bg-white w-full max-w-xs rounded-2xl p-6 flex flex-col items-center gap-6 shadow-xl">
        <div className="size-24 rounded-full bg-red-100 flex items-center justify-center">
          <div className="bg-red-500 rounded-full p-2">
            <X size={40} className="text-white" strokeWidth={3} />
          </div>
        </div>

        <div className="flex flex-col items-center gap-1">
          <h2 className="text-lg font-bold text-clarotexto-201">
            TEMPO EXCEDIDO!
          </h2>
          <p className="text-sm text-gray-500 text-center">
            O tempo de pagamento expirou, por favor, tente novamente.
          </p>
        </div>

        <div className="w-full flex flex-col gap-2">
          <button
            onClick={onGenerateNewPix || onClose}
            className="w-full h-11 border border-claroprimaria-01 text-claroprimaria-01 rounded-xl font-semibold hover:bg-blue-50 transition-colors"
          >
            Gerar novo pix
          </button>
          <button
            onClick={onFinalize || onClose}
            className="w-full h-11 bg-claroprimaria-01 text-white rounded-xl font-semibold hover:bg-claroprimaria-01/90 transition-colors"
          >
            Finalizar
          </button>
        </div>
      </div>
    </div>
  );
}
